import { get, isNil, orderBy, round, uniqBy } from 'lodash';
import { KPI_GREEN, KPI_RED, KPI_YELLOW } from '../../../../core/chart/colors';

export const formatValueByIndicator = (indicator, value) => {
  if (isNil(value) || isNaN(value)) {
    return 'N/A';
  }
  return indicator === 'LEVEL_REACHED_RATE' ? `${value}%` : value;
};

export const getColorByIndicatorAndValue = (indicator, value) => {
  return {
    CORRECT_ANSWERS_RATE: (value) => (value < 3 ? KPI_RED : value >= 7 ? KPI_GREEN : KPI_YELLOW),
    LEVEL_REACHED_RATE: (value) => (value < 50 ? KPI_RED : value >= 80 ? KPI_GREEN : KPI_YELLOW),
  }[indicator](value);
};

export const groupValuesByKey = (dataArray, groupBy) => {
  if (!dataArray.length) {
    return [];
  }

  const groupArray = uniqBy([...dataArray], (x) => get(x, `${groupBy}.id`, null)).map((x) =>
    get(x, groupBy, { id: 'NA', name: 'N/A' })
  );

  return orderBy(
    groupArray.map((group) => {
      const currentGroup = dataArray.find((c) => group.id === get(c, `${groupBy}.id`, 'N/A'));
      return {
        ...group,
        rate: currentGroup ? round(currentGroup.value, 2) : null,
        total: currentGroup.total,
        extra: currentGroup.extra,
      };
    }),
    [`${groupBy}.name`],
    ['asc']
  );
};
